const whatsApp = {
  title: 'WhatsApp',
  subtitle: 'Do you have questions about a medication or possible side effects?',
  paragraph1: 'Not every consultation requires an in-person visit. Simply ask your questions. Your pharmacy will respond securely and discreetly (during opening hours).',
  paragraphMobile: 'Contact us directly via WhatsApp if you have questions.',
  paragraphDesktop: 'Contact us directly via WhatsApp by scanning the QR code or clicking the WhatsApp button to open the chat in your browser.',
  paragraphmobile: 'Kontaktieren Sie uns bei Fragen direkt über WhatsApp.',
  paragraphdesktop: 'Kontaktieren Sie uns direkt über WhatsApp indem Sie den QR-Code scannen oder auf dem WhatsApp-Button klicken, um den Chat im Browser zu öffnen.',
  cartProcess: {
    title: 'You will be redirected to IhreApotheken.de - the digital home of your local pharmacy.',
    subtitle: 'Please wait a moment.',
    missingParameters: 'The URL does not contain the required parameters – Pharmacy-ID and products.',
    singleUnavailableProduct: 'The product {pzn} is unfortunately no longer available. If needed, ask your pharmacy for an alternative.',
    multipleUnavailableProducts: 'The products {pzns} are unfortunately no longer available. If needed, ask your pharmacy for an alternative.',
  },

}

export default whatsApp
